import { inject } from "@angular/core";
import { Component } from "@angular/core";
import { TilbakeLink } from "../../components/tilbake-link/tilbake-link";
import { Beskrivelse } from "./components/beskrivelse/beskrivelse";
import { Tilskudd } from "./components/tilskudd/tilskudd";
import { ActivatedRoute } from "@angular/router";
import { Tiltak } from "../../models/oppsummering.model";

// TODO: koble på dataen fra backend
// TODO Husk: ikke vis tiltakbeskrivelse dersom tiltaket er økonomi

@Component({
  selector: "bko-tiltak-beskrivelse",
  imports: [TilbakeLink, Beskrivelse, Tilskudd],
  templateUrl: "./tiltak-beskrivelse.html",
  styleUrl: "./tiltak-beskrivelse.scss",
})
export class TiltakBeskrivelse {
  private route = inject(ActivatedRoute);
  tiltak: Tiltak = this.route.snapshot.data.tiltak;

  constructor() {
  }
}
